import { createContext } from 'react';

const CreateEditAssignmentContext = createContext({});

export default CreateEditAssignmentContext;
